<template>
	<div class="c-global-search__fieldwrapper">
		<form @submit.prevent="search">
			<DsIconButton
				:aria-label="ariaLabels?.search"
				icon-name="search"
				variant="ghost-neutral"
				size="sm"
				class="c-global-search__icon"
				:class="{ 'c-global-search__icon--hero': flag === 'hero' }"
				:clickHandler="search"
			/>

			<div class="c-global-search__input-wrapper">
				<input
					v-model="localSeachPhrase"
					id="searchField"
					type="search"
					name="q"
					:autofocus="autofocus"
					class="c-global-search__field"
					:class="{ 'c-global-search__field--hero': flag === 'hero' }"
					:placeholder="placeholder || globalSearchModel.SearchBarPlaceholder"
					required
					autocomplete="off"
					data-testid="global-search-field"
					role="combobox"
					:aria-label="ariaLabels?.field"
					aria-haspopup="listbox"
					aria-controls="autosuggest-list"
					aria-autocomplete="list"
					:aria-expanded="globalAutoSuggestSearchResults.length > 0"
				/>

				<DsIconButton
					:aria-label="ariaLabels?.clear"
					icon-name="close"
					variant="ghost-neutral"
					size="sm"
					type="reset"
					class="c-global-search__field-reset"
					:class="{ 'c-global-search__field-reset--hero': flag === 'hero' }"
					:click-handler="() => {reset()}"
				/>
			</div>
		</form>
		<slot></slot>
	</div>
</template>

<script>
import { globalSearchEvents } from 'shared/settings/constants';
import { DsIconButton } from "@coloplast/design-system";
import { mapGetters } from 'vuex';

export default {
	name: 'global-search-field',
	props: {
		prefilledPhrase: {
			type: String,
		},
		placeholder: {
			type: String,
		},
		flag: {
			type: String
		},
		autofocus: {
			type: Boolean,
			default: true,
		},
		ariaLabels: {
			type: Object,
		}
	},
	emits: [
		globalSearchEvents.RESET,
		globalSearchEvents.AUTO_SUGGEST_SEARCH,
		globalSearchEvents.SEARCH,
	],
	data: function () {
		return {
			localSeachPhrase: '',
		};
	},
	computed: {
		...mapGetters({
			globalSearchModel: 'getGlobalSearchModel',
			globalAutoSuggestSearchResults: 'getGlobalAutoSuggestSearchResults',
		}),
	},
	watch: {
		localSeachPhrase(val) {
			if (!val.length) {
				this.$emit(globalSearchEvents.RESET);
			}
			this.$emit(globalSearchEvents.AUTO_SUGGEST_SEARCH);
		},

		prefilledPhrase(newVal) {
			this.localSeachPhrase = newVal;
		}
	},
	mounted() {
		if (this.prefilledPhrase) {
			this.localSeachPhrase = this.prefilledPhrase;
		}
	},
	methods: {
		search() {
			if (this.localSeachPhrase.length) {
				this.$emit(globalSearchEvents.SEARCH, this.localSeachPhrase);
			}
		},
		reset() {
			this.localSeachPhrase = '';
		},
	},

	components: {
		DsIconButton
	}
};
</script>
